import React from 'react';

import './index.css';
import { createRoot } from 'react-dom/client';
import App from './App';
//import * as serviceWorker from './serviceWorker';

import { I18nextProvider } from 'react-i18next';
import i18n, { GetBrowserLanguagePreference } from 'ui-common/i18n';
import { TssCacheProvider } from 'tss-react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const muiCache = createCache({
  key: 'rmd-ms-css',
  container: document.getElementById('rmd-ms-default-style-cache'),
});

const tssCache = createCache({
  key: 'rmd-ms-tss',
  container: document.getElementById('rmd-ms-tss-style-cache'),
});

const WithStyles = props => {
  return (
    <CacheProvider value={muiCache}>
      <TssCacheProvider value={tssCache}>{props.children}</TssCacheProvider>
    </CacheProvider>
  );
};

const render = lang => {
  const root = createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <WithStyles>
        <I18nextProvider i18n={i18n}>
          <App lang={lang} />
        </I18nextProvider>
      </WithStyles>
    </React.StrictMode>
  );
};

GetBrowserLanguagePreference()
  .then(bestLanguage => {
    render(bestLanguage);
  })
  .catch(() => {
    // Fall back to the default language if we can't detect one.
    render();
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
